import React from 'react';
import FlexDiv from '../common/FlexDiv';
import Spacing from '../common/Spacing';
import H from '../elements/H';
import TypedText from '../common/TypedText';
import StaticTim from './StaticTim';

const TimMessage: React.FunctionComponent = ({ children, ...rest }) => {
  return (
    <FlexDiv data-testid="tim-message" {...rest}>
      <Spacing top={[-0.5, -0.5, -0.5, 0]} right={[1, 1.5, 1.5]}>
        <StaticTim size={3} />
      </Spacing>
      <H styling="h4" tag="div" data>
        <TypedText>{children}</TypedText>
      </H>
    </FlexDiv>
  );
};

export default TimMessage;
